import { format, isValid, parseISO } from "date-fns";

/**
 * Safely formats a date string or Date object
 * @param {string|Date} dateValue - The date to format
 * @param {string} formatString - The date-fns format string
 * @param {string} fallbackText - Text to display if date is invalid
 * @returns {string} Formatted date or fallback text
 */
export const formatDate = (dateValue, formatString = "MMM d, yyyy", fallbackText = "No date") => {
  if (!dateValue) return fallbackText;
  
  try {
    // If string, convert to Date object
    let dateObj = dateValue;
    if (typeof dateValue === "string") {
      dateObj = parseISO(dateValue);
    }
    
    // Check if date is valid
    if (!isValid(dateObj)) return fallbackText;
    
    return format(dateObj, formatString);
  } catch (error) {
    console.error("Error formatting date:", error);
    return fallbackText;
  }
};

/**
 * Validates if a value is a valid date
 * @param {any} value - The value to check
 * @returns {boolean} Whether the value is a valid date
 */
export const isValidDate = (value) => {
  if (!value) return false;
  
  try {
    const date = typeof value === "string" ? parseISO(value) : value;
    return isValid(date);
  } catch (error) {
    return false;
  }
};

/**
 * Safely parses an ISO date string to a Date object
 * @param {string} dateString - ISO date string to parse
 * @returns {Date|null} Date object or null if invalid
 */
export const safeParseISO = (dateString) => {
  if (!dateString) return null;
  
  try {
    const date = parseISO(dateString);
    return isValid(date) ? date : null;
  } catch (error) {
    return null;
  }
}; 